module.exports = __webpack_public_path__ + "assets/img/download4.d9214b52.png";